export default __webpack_public_path__ + "static/media/biaoji1.82a50402.svg";